import { configuratorInterface } from '../systems/configurator-interface'
import { PriceInfo } from './price-info'
import { QuantityInput } from './quantity-input'

export const CustomPriceFooter = () => {
  const { rootEntityId } = configuratorInterface.useDomain()

  return (
    <>
      <QuantityInput id={rootEntityId} />
      <PriceInfo />
    </>
  )
}
